import {
  getAdsTxt as publicGetAdsTxt,
  updateAdsTxt as publicUpdateAdsTxt,
  appendAdsTxt as publicAppendAdsTxt,
} from './promote-marketing-v2-ads-txt-ads-txt.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onAdsTxtUpdated as publicOnAdsTxtUpdated } from './promote-marketing-v2-ads-txt-ads-txt.public.js';

export const getAdsTxt: MaybeContext<
  BuildRESTFunction<typeof publicGetAdsTxt> & typeof publicGetAdsTxt
> = /*#__PURE__*/ createRESTModule(publicGetAdsTxt);
export const updateAdsTxt: MaybeContext<
  BuildRESTFunction<typeof publicUpdateAdsTxt> & typeof publicUpdateAdsTxt
> = /*#__PURE__*/ createRESTModule(publicUpdateAdsTxt);
export const appendAdsTxt: MaybeContext<
  BuildRESTFunction<typeof publicAppendAdsTxt> & typeof publicAppendAdsTxt
> = /*#__PURE__*/ createRESTModule(publicAppendAdsTxt);
/** */
export const onAdsTxtUpdated: BuildEventDefinition<
  typeof publicOnAdsTxtUpdated
> &
  typeof publicOnAdsTxtUpdated = /*#__PURE__*/ createEventModule(
  publicOnAdsTxtUpdated
);

export { WebhookIdentityType } from './promote-marketing-v2-ads-txt-ads-txt.universal.js';
export {
  AdsTxt,
  GetAdsTxtRequest,
  GetAdsTxtResponse,
  UpdateAdsTxtRequest,
  UpdateAdsTxtResponse,
  AppendAdsTxtRequest,
  AppendAdsTxtResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  AdsTxtUpdatedEnvelope,
  GetAdsTxtOptions,
  UpdateAdsTxtOptions,
  AppendAdsTxtOptions,
} from './promote-marketing-v2-ads-txt-ads-txt.universal.js';
export { WebhookIdentityTypeWithLiterals } from './promote-marketing-v2-ads-txt-ads-txt.universal.js';
